import {createSelector} from "reselect";
import {sum} from "lodash/math";

const notifications = (state) => state.notifications;
let count = 0;

export const getNotifications = createSelector(
  notifications,
  (notifications) => notifications.notification_list?.results
);

export const getUnreadCount = createSelector(getNotifications, (getNotifications) =>
  getNotifications?.length > 0
    ? sum(getNotifications.map((item) => (!item.is_read ? count + 1 : 0)))
    : 0
);
